import { render, staticRenderFns } from "./store-big-hotsale.vue?vue&type=template&id=2effba08&scoped=true"
import script from "./store-big-hotsale.vue?vue&type=script&lang=js"
export * from "./store-big-hotsale.vue?vue&type=script&lang=js"
import style0 from "./store-big-hotsale.vue?vue&type=style&index=0&id=2effba08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effba08",
  null
  
)

export default component.exports